package flagpack.icons.large

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Iran Flag (32x24dp)
 *
 * - ISO Alpha-2: IR
 * - ISO Alpha-3: IRN
 * - ISO Numeric: 364
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Large.Iran: ImageVector by lazy {
    ImageVector.Builder(
        name = "Iran:IR:IRN:364:Large",
        defaultWidth = 32.dp,
        defaultHeight = 24.dp,
        viewportWidth = 32f,
        viewportHeight = 24f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(24f)
                horizontalLineTo(32f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                verticalLineTo(24f)
                horizontalLineTo(32f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        ) {
            path(
                fill = SolidColor(Color(0xFF5EAA22)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(8f)
                horizontalLineTo(32f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFE31D1C)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 16f)
                verticalLineTo(24f)
                horizontalLineTo(32f)
                verticalLineTo(16f)
                horizontalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(4.601f, 16.392f)
                verticalLineTo(17.026f)
                horizontalLineTo(2.27f)
                verticalLineTo(16.392f)
                horizontalLineTo(4.601f)
                close()
                moveTo(0.566f, 17.984f)
                horizontalLineTo(0.359f)
                verticalLineTo(17.731f)
                horizontalLineTo(0.813f)
                verticalLineTo(18.618f)
                horizontalLineTo(1.393f)
                verticalLineTo(18.625f)
                horizontalLineTo(1.954f)
                verticalLineTo(16.783f)
                horizontalLineTo(1.596f)
                verticalLineTo(17.991f)
                horizontalLineTo(1.54f)
                verticalLineTo(16.687f)
                horizontalLineTo(1.182f)
                verticalLineTo(17.984f)
                horizontalLineTo(1.172f)
                verticalLineTo(17.731f)
                verticalLineTo(16.687f)
                horizontalLineTo(0.813f)
                verticalLineTo(17.097f)
                horizontalLineTo(0f)
                verticalLineTo(18.618f)
                horizontalLineTo(0.179f)
                horizontalLineTo(0.566f)
                verticalLineTo(17.984f)
                close()
                moveTo(2.067f, 18.34f)
                horizontalLineTo(2.425f)
                verticalLineTo(17.711f)
                horizontalLineTo(2.825f)
                verticalLineTo(18.625f)
                horizontalLineTo(3.951f)
                verticalLineTo(17.078f)
                horizontalLineTo(3.374f)
                verticalLineTo(17.712f)
                horizontalLineTo(3.592f)
                verticalLineTo(17.991f)
                horizontalLineTo(3.184f)
                verticalLineTo(17.077f)
                horizontalLineTo(2.067f)
                verticalLineTo(18.34f)
                close()
                moveTo(4.358f, 17.984f)
                horizontalLineTo(4.565f)
                verticalLineTo(18.618f)
                horizontalLineTo(4.179f)
                horizontalLineTo(4f)
                verticalLineTo(17.097f)
                horizontalLineTo(4.813f)
                verticalLineTo(16.687f)
                horizontalLineTo(5.172f)
                verticalLineTo(17.731f)
                verticalLineTo(17.984f)
                horizontalLineTo(5.181f)
                verticalLineTo(16.687f)
                horizontalLineTo(5.54f)
                verticalLineTo(17.991f)
                horizontalLineTo(5.595f)
                verticalLineTo(16.783f)
                horizontalLineTo(5.954f)
                verticalLineTo(18.625f)
                horizontalLineTo(5.393f)
                verticalLineTo(18.618f)
                horizontalLineTo(4.813f)
                verticalLineTo(17.731f)
                horizontalLineTo(4.358f)
                verticalLineTo(17.984f)
                close()
                moveTo(8.6f, 16.392f)
                verticalLineTo(17.026f)
                horizontalLineTo(6.27f)
                verticalLineTo(16.392f)
                horizontalLineTo(8.6f)
                close()
                moveTo(6.066f, 18.34f)
                horizontalLineTo(6.425f)
                verticalLineTo(17.711f)
                horizontalLineTo(6.825f)
                verticalLineTo(18.625f)
                horizontalLineTo(7.95f)
                verticalLineTo(17.078f)
                horizontalLineTo(7.373f)
                verticalLineTo(17.712f)
                horizontalLineTo(7.592f)
                verticalLineTo(17.991f)
                horizontalLineTo(7.184f)
                verticalLineTo(17.077f)
                horizontalLineTo(6.066f)
                verticalLineTo(18.34f)
                close()
                moveTo(8.43f, 17.984f)
                horizontalLineTo(8.637f)
                verticalLineTo(18.618f)
                horizontalLineTo(8.25f)
                horizontalLineTo(8.071f)
                verticalLineTo(17.097f)
                horizontalLineTo(8.884f)
                verticalLineTo(16.687f)
                horizontalLineTo(9.243f)
                verticalLineTo(17.731f)
                verticalLineTo(17.984f)
                horizontalLineTo(9.252f)
                verticalLineTo(16.687f)
                horizontalLineTo(9.611f)
                verticalLineTo(17.991f)
                horizontalLineTo(9.667f)
                verticalLineTo(16.783f)
                horizontalLineTo(10.025f)
                verticalLineTo(18.625f)
                horizontalLineTo(9.464f)
                verticalLineTo(18.618f)
                horizontalLineTo(8.884f)
                verticalLineTo(17.731f)
                horizontalLineTo(8.43f)
                verticalLineTo(17.984f)
                close()
                moveTo(12.672f, 16.392f)
                verticalLineTo(17.026f)
                horizontalLineTo(10.341f)
                verticalLineTo(16.392f)
                horizontalLineTo(12.672f)
                close()
                moveTo(10.137f, 18.34f)
                horizontalLineTo(10.496f)
                verticalLineTo(17.711f)
                horizontalLineTo(10.896f)
                verticalLineTo(18.625f)
                horizontalLineTo(12.022f)
                verticalLineTo(17.078f)
                horizontalLineTo(11.444f)
                verticalLineTo(17.712f)
                horizontalLineTo(11.663f)
                verticalLineTo(17.991f)
                horizontalLineTo(11.255f)
                verticalLineTo(17.077f)
                horizontalLineTo(10.137f)
                verticalLineTo(18.34f)
                close()
                moveTo(12.429f, 17.984f)
                horizontalLineTo(12.636f)
                verticalLineTo(18.618f)
                horizontalLineTo(12.25f)
                horizontalLineTo(12.071f)
                verticalLineTo(17.097f)
                horizontalLineTo(12.884f)
                verticalLineTo(16.687f)
                horizontalLineTo(13.243f)
                verticalLineTo(17.731f)
                verticalLineTo(17.984f)
                horizontalLineTo(13.252f)
                verticalLineTo(16.687f)
                horizontalLineTo(13.611f)
                verticalLineTo(17.991f)
                horizontalLineTo(13.666f)
                verticalLineTo(16.783f)
                horizontalLineTo(14.025f)
                verticalLineTo(18.625f)
                horizontalLineTo(13.464f)
                verticalLineTo(18.618f)
                horizontalLineTo(12.884f)
                verticalLineTo(17.731f)
                horizontalLineTo(12.429f)
                verticalLineTo(17.984f)
                close()
                moveTo(16.671f, 16.392f)
                verticalLineTo(17.026f)
                horizontalLineTo(14.341f)
                verticalLineTo(16.392f)
                horizontalLineTo(16.671f)
                close()
                moveTo(14.137f, 18.34f)
                horizontalLineTo(14.496f)
                verticalLineTo(17.711f)
                horizontalLineTo(14.896f)
                verticalLineTo(18.625f)
                horizontalLineTo(16.021f)
                verticalLineTo(17.078f)
                horizontalLineTo(15.444f)
                verticalLineTo(17.712f)
                horizontalLineTo(15.663f)
                verticalLineTo(17.991f)
                horizontalLineTo(15.255f)
                verticalLineTo(17.077f)
                horizontalLineTo(14.137f)
                verticalLineTo(18.34f)
                close()
                moveTo(16.429f, 17.984f)
                horizontalLineTo(16.636f)
                verticalLineTo(18.618f)
                horizontalLineTo(16.25f)
                horizontalLineTo(16.07f)
                verticalLineTo(17.097f)
                horizontalLineTo(16.884f)
                verticalLineTo(16.687f)
                horizontalLineTo(17.243f)
                verticalLineTo(17.731f)
                verticalLineTo(17.984f)
                horizontalLineTo(17.252f)
                verticalLineTo(16.687f)
                horizontalLineTo(17.611f)
                verticalLineTo(17.991f)
                horizontalLineTo(17.666f)
                verticalLineTo(16.783f)
                horizontalLineTo(18.025f)
                verticalLineTo(18.625f)
                horizontalLineTo(17.463f)
                verticalLineTo(18.618f)
                horizontalLineTo(16.884f)
                verticalLineTo(17.731f)
                horizontalLineTo(16.429f)
                verticalLineTo(17.984f)
                close()
                moveTo(20.671f, 16.392f)
                verticalLineTo(17.026f)
                horizontalLineTo(18.34f)
                verticalLineTo(16.392f)
                horizontalLineTo(20.671f)
                close()
                moveTo(18.137f, 18.34f)
                horizontalLineTo(18.496f)
                verticalLineTo(17.711f)
                horizontalLineTo(18.896f)
                verticalLineTo(18.625f)
                horizontalLineTo(20.021f)
                verticalLineTo(17.078f)
                horizontalLineTo(19.444f)
                verticalLineTo(17.712f)
                horizontalLineTo(19.662f)
                verticalLineTo(17.991f)
                horizontalLineTo(19.254f)
                verticalLineTo(17.077f)
                horizontalLineTo(18.137f)
                verticalLineTo(18.34f)
                close()
                moveTo(20.5f, 17.984f)
                horizontalLineTo(20.707f)
                verticalLineTo(18.618f)
                horizontalLineTo(20.321f)
                horizontalLineTo(20.142f)
                verticalLineTo(17.097f)
                horizontalLineTo(20.955f)
                verticalLineTo(16.687f)
                horizontalLineTo(21.314f)
                verticalLineTo(17.731f)
                verticalLineTo(17.984f)
                horizontalLineTo(21.323f)
                verticalLineTo(16.687f)
                horizontalLineTo(21.682f)
                verticalLineTo(17.991f)
                horizontalLineTo(21.737f)
                verticalLineTo(16.783f)
                horizontalLineTo(22.096f)
                verticalLineTo(18.625f)
                horizontalLineTo(21.535f)
                verticalLineTo(18.618f)
                horizontalLineTo(20.955f)
                verticalLineTo(17.731f)
                horizontalLineTo(20.5f)
                verticalLineTo(17.984f)
                close()
                moveTo(24.742f, 16.392f)
                verticalLineTo(17.026f)
                horizontalLineTo(22.412f)
                verticalLineTo(16.392f)
                horizontalLineTo(24.742f)
                close()
                moveTo(22.208f, 18.34f)
                horizontalLineTo(22.567f)
                verticalLineTo(17.711f)
                horizontalLineTo(22.967f)
                verticalLineTo(18.625f)
                horizontalLineTo(24.092f)
                verticalLineTo(17.078f)
                horizontalLineTo(23.515f)
                verticalLineTo(17.712f)
                horizontalLineTo(23.734f)
                verticalLineTo(17.991f)
                horizontalLineTo(23.326f)
                verticalLineTo(17.077f)
                horizontalLineTo(22.208f)
                verticalLineTo(18.34f)
                close()
                moveTo(24.572f, 17.984f)
                horizontalLineTo(24.778f)
                verticalLineTo(18.618f)
                horizontalLineTo(24.392f)
                horizontalLineTo(24.213f)
                verticalLineTo(17.097f)
                horizontalLineTo(25.026f)
                verticalLineTo(16.687f)
                horizontalLineTo(25.385f)
                verticalLineTo(17.731f)
                verticalLineTo(17.984f)
                horizontalLineTo(25.394f)
                verticalLineTo(16.687f)
                horizontalLineTo(25.753f)
                verticalLineTo(17.991f)
                horizontalLineTo(25.809f)
                verticalLineTo(16.783f)
                horizontalLineTo(26.167f)
                verticalLineTo(18.625f)
                horizontalLineTo(25.606f)
                verticalLineTo(18.618f)
                horizontalLineTo(25.026f)
                verticalLineTo(17.731f)
                horizontalLineTo(24.572f)
                verticalLineTo(17.984f)
                close()
                moveTo(28.813f, 16.392f)
                verticalLineTo(17.026f)
                horizontalLineTo(26.483f)
                verticalLineTo(16.392f)
                horizontalLineTo(28.813f)
                close()
                moveTo(26.279f, 18.34f)
                horizontalLineTo(26.638f)
                verticalLineTo(17.711f)
                horizontalLineTo(27.038f)
                verticalLineTo(18.625f)
                horizontalLineTo(28.163f)
                verticalLineTo(17.078f)
                horizontalLineTo(27.586f)
                verticalLineTo(17.712f)
                horizontalLineTo(27.805f)
                verticalLineTo(17.991f)
                horizontalLineTo(27.397f)
                verticalLineTo(17.077f)
                horizontalLineTo(26.279f)
                verticalLineTo(18.34f)
                close()
                moveTo(28.643f, 17.984f)
                horizontalLineTo(28.85f)
                verticalLineTo(18.618f)
                horizontalLineTo(28.463f)
                horizontalLineTo(28.284f)
                verticalLineTo(17.097f)
                horizontalLineTo(29.097f)
                verticalLineTo(16.687f)
                horizontalLineTo(29.456f)
                verticalLineTo(17.731f)
                verticalLineTo(17.984f)
                horizontalLineTo(29.465f)
                verticalLineTo(16.687f)
                horizontalLineTo(29.824f)
                verticalLineTo(17.991f)
                horizontalLineTo(29.88f)
                verticalLineTo(16.783f)
                horizontalLineTo(30.238f)
                verticalLineTo(18.625f)
                horizontalLineTo(29.677f)
                verticalLineTo(18.618f)
                horizontalLineTo(29.097f)
                verticalLineTo(17.731f)
                horizontalLineTo(28.643f)
                verticalLineTo(17.984f)
                close()
                moveTo(32.885f, 16.392f)
                verticalLineTo(17.026f)
                horizontalLineTo(30.554f)
                verticalLineTo(16.392f)
                horizontalLineTo(32.885f)
                close()
                moveTo(30.351f, 18.34f)
                horizontalLineTo(30.709f)
                verticalLineTo(17.711f)
                horizontalLineTo(31.109f)
                verticalLineTo(18.625f)
                horizontalLineTo(32.235f)
                verticalLineTo(17.078f)
                horizontalLineTo(31.658f)
                verticalLineTo(17.712f)
                horizontalLineTo(31.876f)
                verticalLineTo(17.991f)
                horizontalLineTo(31.468f)
                verticalLineTo(17.077f)
                horizontalLineTo(30.351f)
                verticalLineTo(18.34f)
                close()
                moveTo(32.643f, 17.984f)
                horizontalLineTo(32.849f)
                verticalLineTo(18.618f)
                horizontalLineTo(32.463f)
                horizontalLineTo(32.284f)
                verticalLineTo(17.097f)
                horizontalLineTo(33.097f)
                verticalLineTo(16.687f)
                horizontalLineTo(33.456f)
                verticalLineTo(17.731f)
                verticalLineTo(17.984f)
                horizontalLineTo(33.465f)
                verticalLineTo(16.687f)
                horizontalLineTo(33.824f)
                verticalLineTo(17.991f)
                horizontalLineTo(33.879f)
                verticalLineTo(16.783f)
                horizontalLineTo(34.238f)
                verticalLineTo(18.625f)
                horizontalLineTo(33.677f)
                verticalLineTo(18.618f)
                horizontalLineTo(33.097f)
                verticalLineTo(17.731f)
                horizontalLineTo(32.643f)
                verticalLineTo(17.984f)
                close()
                moveTo(36.884f, 16.392f)
                verticalLineTo(17.026f)
                horizontalLineTo(34.554f)
                verticalLineTo(16.392f)
                horizontalLineTo(36.884f)
                close()
                moveTo(34.35f, 18.34f)
                horizontalLineTo(34.709f)
                verticalLineTo(17.711f)
                horizontalLineTo(35.109f)
                verticalLineTo(18.625f)
                horizontalLineTo(36.234f)
                verticalLineTo(17.078f)
                horizontalLineTo(35.657f)
                verticalLineTo(17.712f)
                horizontalLineTo(35.876f)
                verticalLineTo(17.991f)
                horizontalLineTo(35.468f)
                verticalLineTo(17.077f)
                horizontalLineTo(34.35f)
                verticalLineTo(18.34f)
                close()
                moveTo(36.856f, 17.984f)
                horizontalLineTo(37.063f)
                verticalLineTo(18.618f)
                horizontalLineTo(36.677f)
                horizontalLineTo(36.498f)
                verticalLineTo(17.097f)
                horizontalLineTo(37.311f)
                verticalLineTo(16.687f)
                horizontalLineTo(37.67f)
                verticalLineTo(17.731f)
                verticalLineTo(17.984f)
                horizontalLineTo(37.679f)
                verticalLineTo(16.687f)
                horizontalLineTo(38.038f)
                verticalLineTo(17.991f)
                horizontalLineTo(38.093f)
                verticalLineTo(16.783f)
                horizontalLineTo(38.452f)
                verticalLineTo(18.625f)
                horizontalLineTo(37.891f)
                verticalLineTo(18.618f)
                horizontalLineTo(37.311f)
                verticalLineTo(17.731f)
                horizontalLineTo(36.856f)
                verticalLineTo(17.984f)
                close()
                moveTo(41.098f, 16.392f)
                verticalLineTo(17.026f)
                horizontalLineTo(38.768f)
                verticalLineTo(16.392f)
                horizontalLineTo(41.098f)
                close()
                moveTo(38.564f, 18.34f)
                horizontalLineTo(38.923f)
                verticalLineTo(17.711f)
                horizontalLineTo(39.323f)
                verticalLineTo(18.625f)
                horizontalLineTo(40.449f)
                verticalLineTo(17.078f)
                horizontalLineTo(39.871f)
                verticalLineTo(17.712f)
                horizontalLineTo(40.09f)
                verticalLineTo(17.991f)
                horizontalLineTo(39.682f)
                verticalLineTo(17.077f)
                horizontalLineTo(38.564f)
                verticalLineTo(18.34f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0.485f, 5.392f)
                verticalLineTo(6.026f)
                horizontalLineTo(-1.846f)
                verticalLineTo(5.392f)
                horizontalLineTo(0.485f)
                close()
                moveTo(-3.55f, 6.984f)
                horizontalLineTo(-3.757f)
                verticalLineTo(6.731f)
                horizontalLineTo(-3.303f)
                verticalLineTo(7.618f)
                horizontalLineTo(-2.723f)
                verticalLineTo(7.625f)
                horizontalLineTo(-2.162f)
                verticalLineTo(5.783f)
                horizontalLineTo(-2.52f)
                verticalLineTo(6.991f)
                horizontalLineTo(-2.576f)
                verticalLineTo(5.687f)
                horizontalLineTo(-2.935f)
                verticalLineTo(6.984f)
                horizontalLineTo(-2.944f)
                verticalLineTo(6.731f)
                verticalLineTo(5.687f)
                horizontalLineTo(-3.303f)
                verticalLineTo(6.097f)
                horizontalLineTo(-4.116f)
                verticalLineTo(7.618f)
                horizontalLineTo(-3.937f)
                horizontalLineTo(-3.55f)
                verticalLineTo(6.984f)
                close()
                moveTo(-2.05f, 7.339f)
                horizontalLineTo(-1.691f)
                verticalLineTo(6.711f)
                horizontalLineTo(-1.291f)
                verticalLineTo(7.625f)
                horizontalLineTo(-0.165f)
                verticalLineTo(6.078f)
                horizontalLineTo(-0.743f)
                verticalLineTo(6.712f)
                horizontalLineTo(-0.524f)
                verticalLineTo(6.991f)
                horizontalLineTo(-0.932f)
                verticalLineTo(6.077f)
                horizontalLineTo(-2.05f)
                verticalLineTo(7.339f)
                close()
                moveTo(0.242f, 6.984f)
                horizontalLineTo(0.449f)
                verticalLineTo(7.618f)
                horizontalLineTo(0.063f)
                horizontalLineTo(-0.116f)
                verticalLineTo(6.097f)
                horizontalLineTo(0.697f)
                verticalLineTo(5.687f)
                horizontalLineTo(1.056f)
                verticalLineTo(6.731f)
                verticalLineTo(6.984f)
                horizontalLineTo(1.065f)
                verticalLineTo(5.687f)
                horizontalLineTo(1.424f)
                verticalLineTo(6.991f)
                horizontalLineTo(1.479f)
                verticalLineTo(5.783f)
                horizontalLineTo(1.838f)
                verticalLineTo(7.625f)
                horizontalLineTo(1.277f)
                verticalLineTo(7.618f)
                horizontalLineTo(0.697f)
                verticalLineTo(6.731f)
                horizontalLineTo(0.242f)
                verticalLineTo(6.984f)
                close()
                moveTo(4.484f, 5.392f)
                verticalLineTo(6.026f)
                horizontalLineTo(2.154f)
                verticalLineTo(5.392f)
                horizontalLineTo(4.484f)
                close()
                moveTo(1.95f, 7.339f)
                horizontalLineTo(2.309f)
                verticalLineTo(6.711f)
                horizontalLineTo(2.709f)
                verticalLineTo(7.625f)
                horizontalLineTo(3.834f)
                verticalLineTo(6.078f)
                horizontalLineTo(3.257f)
                verticalLineTo(6.712f)
                horizontalLineTo(3.476f)
                verticalLineTo(6.991f)
                horizontalLineTo(3.068f)
                verticalLineTo(6.077f)
                horizontalLineTo(1.95f)
                verticalLineTo(7.339f)
                close()
                moveTo(4.314f, 6.984f)
                horizontalLineTo(4.521f)
                verticalLineTo(7.618f)
                horizontalLineTo(4.134f)
                horizontalLineTo(3.955f)
                verticalLineTo(6.097f)
                horizontalLineTo(4.768f)
                verticalLineTo(5.687f)
                horizontalLineTo(5.127f)
                verticalLineTo(6.731f)
                verticalLineTo(6.984f)
                horizontalLineTo(5.136f)
                verticalLineTo(5.687f)
                horizontalLineTo(5.495f)
                verticalLineTo(6.991f)
                horizontalLineTo(5.55f)
                verticalLineTo(5.783f)
                horizontalLineTo(5.909f)
                verticalLineTo(7.625f)
                horizontalLineTo(5.348f)
                verticalLineTo(7.618f)
                horizontalLineTo(4.768f)
                verticalLineTo(6.731f)
                horizontalLineTo(4.314f)
                verticalLineTo(6.984f)
                close()
                moveTo(8.556f, 5.392f)
                verticalLineTo(6.026f)
                horizontalLineTo(6.225f)
                verticalLineTo(5.392f)
                horizontalLineTo(8.556f)
                close()
                moveTo(6.021f, 7.339f)
                horizontalLineTo(6.38f)
                verticalLineTo(6.711f)
                horizontalLineTo(6.78f)
                verticalLineTo(7.625f)
                horizontalLineTo(7.906f)
                verticalLineTo(6.078f)
                horizontalLineTo(7.328f)
                verticalLineTo(6.712f)
                horizontalLineTo(7.547f)
                verticalLineTo(6.991f)
                horizontalLineTo(7.139f)
                verticalLineTo(6.077f)
                horizontalLineTo(6.021f)
                verticalLineTo(7.339f)
                close()
                moveTo(8.313f, 6.984f)
                horizontalLineTo(8.52f)
                verticalLineTo(7.618f)
                horizontalLineTo(8.134f)
                horizontalLineTo(7.955f)
                verticalLineTo(6.097f)
                horizontalLineTo(8.768f)
                verticalLineTo(5.687f)
                horizontalLineTo(9.127f)
                verticalLineTo(6.731f)
                verticalLineTo(6.984f)
                horizontalLineTo(9.136f)
                verticalLineTo(5.687f)
                horizontalLineTo(9.495f)
                verticalLineTo(6.991f)
                horizontalLineTo(9.55f)
                verticalLineTo(5.783f)
                horizontalLineTo(9.909f)
                verticalLineTo(7.625f)
                horizontalLineTo(9.348f)
                verticalLineTo(7.618f)
                horizontalLineTo(8.768f)
                verticalLineTo(6.731f)
                horizontalLineTo(8.313f)
                verticalLineTo(6.984f)
                close()
                moveTo(12.555f, 5.392f)
                verticalLineTo(6.026f)
                horizontalLineTo(10.224f)
                verticalLineTo(5.392f)
                horizontalLineTo(12.555f)
                close()
                moveTo(10.021f, 7.339f)
                horizontalLineTo(10.38f)
                verticalLineTo(6.711f)
                horizontalLineTo(10.78f)
                verticalLineTo(7.625f)
                horizontalLineTo(11.905f)
                verticalLineTo(6.078f)
                horizontalLineTo(11.328f)
                verticalLineTo(6.712f)
                horizontalLineTo(11.547f)
                verticalLineTo(6.991f)
                horizontalLineTo(11.139f)
                verticalLineTo(6.077f)
                horizontalLineTo(10.021f)
                verticalLineTo(7.339f)
                close()
                moveTo(12.313f, 6.984f)
                horizontalLineTo(12.52f)
                verticalLineTo(7.618f)
                horizontalLineTo(12.134f)
                horizontalLineTo(11.954f)
                verticalLineTo(6.097f)
                horizontalLineTo(12.768f)
                verticalLineTo(5.687f)
                horizontalLineTo(13.127f)
                verticalLineTo(6.731f)
                verticalLineTo(6.984f)
                horizontalLineTo(13.136f)
                verticalLineTo(5.687f)
                horizontalLineTo(13.495f)
                verticalLineTo(6.991f)
                horizontalLineTo(13.55f)
                verticalLineTo(5.783f)
                horizontalLineTo(13.909f)
                verticalLineTo(7.625f)
                horizontalLineTo(13.347f)
                verticalLineTo(7.618f)
                horizontalLineTo(12.768f)
                verticalLineTo(6.731f)
                horizontalLineTo(12.313f)
                verticalLineTo(6.984f)
                close()
                moveTo(16.555f, 5.392f)
                verticalLineTo(6.026f)
                horizontalLineTo(14.224f)
                verticalLineTo(5.392f)
                horizontalLineTo(16.555f)
                close()
                moveTo(14.021f, 7.339f)
                horizontalLineTo(14.38f)
                verticalLineTo(6.711f)
                horizontalLineTo(14.78f)
                verticalLineTo(7.625f)
                horizontalLineTo(15.905f)
                verticalLineTo(6.078f)
                horizontalLineTo(15.328f)
                verticalLineTo(6.712f)
                horizontalLineTo(15.546f)
                verticalLineTo(6.991f)
                horizontalLineTo(15.138f)
                verticalLineTo(6.077f)
                horizontalLineTo(14.021f)
                verticalLineTo(7.339f)
                close()
                moveTo(16.384f, 6.984f)
                horizontalLineTo(16.591f)
                verticalLineTo(7.618f)
                horizontalLineTo(16.205f)
                horizontalLineTo(16.026f)
                verticalLineTo(6.097f)
                horizontalLineTo(16.839f)
                verticalLineTo(5.687f)
                horizontalLineTo(17.198f)
                verticalLineTo(6.731f)
                verticalLineTo(6.984f)
                horizontalLineTo(17.207f)
                verticalLineTo(5.687f)
                horizontalLineTo(17.566f)
                verticalLineTo(6.991f)
                horizontalLineTo(17.621f)
                verticalLineTo(5.783f)
                horizontalLineTo(17.98f)
                verticalLineTo(7.625f)
                horizontalLineTo(17.419f)
                verticalLineTo(7.618f)
                horizontalLineTo(16.839f)
                verticalLineTo(6.731f)
                horizontalLineTo(16.384f)
                verticalLineTo(6.984f)
                close()
                moveTo(20.626f, 5.392f)
                verticalLineTo(6.026f)
                horizontalLineTo(18.295f)
                verticalLineTo(5.392f)
                horizontalLineTo(20.626f)
                close()
                moveTo(18.092f, 7.339f)
                horizontalLineTo(18.451f)
                verticalLineTo(6.711f)
                horizontalLineTo(18.851f)
                verticalLineTo(7.625f)
                horizontalLineTo(19.976f)
                verticalLineTo(6.078f)
                horizontalLineTo(19.399f)
                verticalLineTo(6.712f)
                horizontalLineTo(19.618f)
                verticalLineTo(6.991f)
                horizontalLineTo(19.209f)
                verticalLineTo(6.077f)
                horizontalLineTo(18.092f)
                verticalLineTo(7.339f)
                close()
                moveTo(20.455f, 6.984f)
                horizontalLineTo(20.662f)
                verticalLineTo(7.618f)
                horizontalLineTo(20.276f)
                horizontalLineTo(20.097f)
                verticalLineTo(6.097f)
                horizontalLineTo(20.91f)
                verticalLineTo(5.687f)
                horizontalLineTo(21.269f)
                verticalLineTo(6.731f)
                verticalLineTo(6.984f)
                horizontalLineTo(21.278f)
                verticalLineTo(5.687f)
                horizontalLineTo(21.637f)
                verticalLineTo(6.991f)
                horizontalLineTo(21.692f)
                verticalLineTo(5.783f)
                horizontalLineTo(22.051f)
                verticalLineTo(7.625f)
                horizontalLineTo(21.49f)
                verticalLineTo(7.618f)
                horizontalLineTo(20.91f)
                verticalLineTo(6.731f)
                horizontalLineTo(20.455f)
                verticalLineTo(6.984f)
                close()
                moveTo(24.697f, 5.392f)
                verticalLineTo(6.026f)
                horizontalLineTo(22.367f)
                verticalLineTo(5.392f)
                horizontalLineTo(24.697f)
                close()
                moveTo(22.163f, 7.339f)
                horizontalLineTo(22.522f)
                verticalLineTo(6.711f)
                horizontalLineTo(22.922f)
                verticalLineTo(7.625f)
                horizontalLineTo(24.047f)
                verticalLineTo(6.078f)
                horizontalLineTo(23.47f)
                verticalLineTo(6.712f)
                horizontalLineTo(23.689f)
                verticalLineTo(6.991f)
                horizontalLineTo(23.281f)
                verticalLineTo(6.077f)
                horizontalLineTo(22.163f)
                verticalLineTo(7.339f)
                close()
                moveTo(24.527f, 6.984f)
                horizontalLineTo(24.734f)
                verticalLineTo(7.618f)
                horizontalLineTo(24.347f)
                horizontalLineTo(24.168f)
                verticalLineTo(6.097f)
                horizontalLineTo(24.981f)
                verticalLineTo(5.687f)
                horizontalLineTo(25.34f)
                verticalLineTo(6.731f)
                verticalLineTo(6.984f)
                horizontalLineTo(25.349f)
                verticalLineTo(5.687f)
                horizontalLineTo(25.708f)
                verticalLineTo(6.991f)
                horizontalLineTo(25.764f)
                verticalLineTo(5.783f)
                horizontalLineTo(26.122f)
                verticalLineTo(7.625f)
                horizontalLineTo(25.561f)
                verticalLineTo(7.618f)
                horizontalLineTo(24.981f)
                verticalLineTo(6.731f)
                horizontalLineTo(24.527f)
                verticalLineTo(6.984f)
                close()
                moveTo(28.769f, 5.392f)
                verticalLineTo(6.026f)
                horizontalLineTo(26.438f)
                verticalLineTo(5.392f)
                horizontalLineTo(28.769f)
                close()
                moveTo(26.235f, 7.339f)
                horizontalLineTo(26.593f)
                verticalLineTo(6.711f)
                horizontalLineTo(26.993f)
                verticalLineTo(7.625f)
                horizontalLineTo(28.119f)
                verticalLineTo(6.078f)
                horizontalLineTo(27.542f)
                verticalLineTo(6.712f)
                horizontalLineTo(27.76f)
                verticalLineTo(6.991f)
                horizontalLineTo(27.352f)
                verticalLineTo(6.077f)
                horizontalLineTo(26.235f)
                verticalLineTo(7.339f)
                close()
                moveTo(28.526f, 6.984f)
                horizontalLineTo(28.733f)
                verticalLineTo(7.618f)
                horizontalLineTo(28.347f)
                horizontalLineTo(28.168f)
                verticalLineTo(6.097f)
                horizontalLineTo(28.981f)
                verticalLineTo(5.687f)
                horizontalLineTo(29.34f)
                verticalLineTo(6.731f)
                verticalLineTo(6.984f)
                horizontalLineTo(29.349f)
                verticalLineTo(5.687f)
                horizontalLineTo(29.708f)
                verticalLineTo(6.991f)
                horizontalLineTo(29.763f)
                verticalLineTo(5.783f)
                horizontalLineTo(30.122f)
                verticalLineTo(7.625f)
                horizontalLineTo(29.561f)
                verticalLineTo(7.618f)
                horizontalLineTo(28.981f)
                verticalLineTo(6.731f)
                horizontalLineTo(28.526f)
                verticalLineTo(6.984f)
                close()
                moveTo(32.768f, 5.392f)
                verticalLineTo(6.026f)
                horizontalLineTo(30.438f)
                verticalLineTo(5.392f)
                horizontalLineTo(32.768f)
                close()
                moveTo(30.234f, 7.339f)
                horizontalLineTo(30.593f)
                verticalLineTo(6.711f)
                horizontalLineTo(30.993f)
                verticalLineTo(7.625f)
                horizontalLineTo(32.118f)
                verticalLineTo(6.078f)
                horizontalLineTo(31.541f)
                verticalLineTo(6.712f)
                horizontalLineTo(31.76f)
                verticalLineTo(6.991f)
                horizontalLineTo(31.352f)
                verticalLineTo(6.077f)
                horizontalLineTo(30.234f)
                verticalLineTo(7.339f)
                close()
                moveTo(32.741f, 6.984f)
                horizontalLineTo(32.947f)
                verticalLineTo(7.618f)
                horizontalLineTo(32.561f)
                horizontalLineTo(32.382f)
                verticalLineTo(6.097f)
                horizontalLineTo(33.195f)
                verticalLineTo(5.687f)
                horizontalLineTo(33.554f)
                verticalLineTo(6.731f)
                verticalLineTo(6.984f)
                horizontalLineTo(33.563f)
                verticalLineTo(5.687f)
                horizontalLineTo(33.922f)
                verticalLineTo(6.991f)
                horizontalLineTo(33.977f)
                verticalLineTo(5.783f)
                horizontalLineTo(34.336f)
                verticalLineTo(7.625f)
                horizontalLineTo(33.775f)
                verticalLineTo(7.618f)
                horizontalLineTo(33.195f)
                verticalLineTo(6.731f)
                horizontalLineTo(32.741f)
                verticalLineTo(6.984f)
                close()
                moveTo(36.982f, 5.392f)
                verticalLineTo(6.026f)
                horizontalLineTo(34.652f)
                verticalLineTo(5.392f)
                horizontalLineTo(36.982f)
                close()
                moveTo(34.448f, 7.339f)
                horizontalLineTo(34.807f)
                verticalLineTo(6.711f)
                horizontalLineTo(35.207f)
                verticalLineTo(7.625f)
                horizontalLineTo(36.332f)
                verticalLineTo(6.078f)
                horizontalLineTo(35.755f)
                verticalLineTo(6.712f)
                horizontalLineTo(35.974f)
                verticalLineTo(6.991f)
                horizontalLineTo(35.566f)
                verticalLineTo(6.077f)
                horizontalLineTo(34.448f)
                verticalLineTo(7.339f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFE31D1C)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(14.606f, 8.25f)
                curveTo(14.606f, 8.25f, 15.034f, 8.475f, 15.471f, 8.475f)
                curveTo(15.908f, 8.475f, 16.348f, 8.25f, 16.348f, 8.25f)
                verticalLineTo(8.55f)
                curveTo(16.348f, 8.55f, 15.868f, 8.775f, 15.443f, 8.775f)
                curveTo(15.017f, 8.775f, 14.606f, 8.55f, 14.606f, 8.55f)
                verticalLineTo(8.25f)
                close()
                moveTo(11.456f, 11.791f)
                curveTo(11.456f, 10.013f, 13.898f, 8.85f, 13.898f, 8.85f)
                curveTo(13.898f, 8.85f, 12.487f, 9.606f, 12.487f, 11.716f)
                curveTo(12.487f, 13.826f, 13.22f, 14.74f, 13.22f, 14.74f)
                curveTo(13.22f, 14.74f, 11.456f, 13.569f, 11.456f, 11.791f)
                close()
                moveTo(19.694f, 11.693f)
                curveTo(19.694f, 9.914f, 17.254f, 8.85f, 17.254f, 8.85f)
                curveTo(17.254f, 8.85f, 18.666f, 9.606f, 18.666f, 11.716f)
                curveTo(18.666f, 13.826f, 17.933f, 14.74f, 17.933f, 14.74f)
                curveTo(17.933f, 14.74f, 19.694f, 13.47f, 19.694f, 11.693f)
                close()
                moveTo(13.123f, 12.178f)
                curveTo(13.031f, 10.402f, 14.507f, 8.811f, 14.507f, 8.811f)
                curveTo(14.507f, 8.811f, 13.97f, 9.542f, 14.08f, 11.649f)
                curveTo(14.118f, 12.372f, 14.403f, 13.449f, 14.762f, 14.083f)
                verticalLineTo(8.925f)
                horizontalLineTo(16.262f)
                verticalLineTo(14.128f)
                curveTo(16.622f, 13.535f, 16.899f, 12.525f, 16.937f, 11.791f)
                curveTo(17.048f, 9.684f, 16.536f, 8.811f, 16.536f, 8.811f)
                curveTo(16.536f, 8.811f, 18.013f, 10.402f, 17.92f, 12.178f)
                curveTo(17.864f, 13.235f, 17.051f, 14.353f, 16.402f, 15.085f)
                curveTo(16.717f, 15.155f, 17.14f, 15.241f, 17.721f, 15.356f)
                curveTo(17.733f, 15.42f, 17.604f, 15.417f, 17.347f, 15.411f)
                curveTo(17.062f, 15.405f, 16.622f, 15.395f, 16.046f, 15.467f)
                curveTo(15.781f, 15.739f, 15.596f, 15.9f, 15.596f, 15.9f)
                curveTo(15.596f, 15.9f, 15.567f, 15.861f, 15.522f, 15.806f)
                curveTo(15.477f, 15.861f, 15.447f, 15.9f, 15.447f, 15.9f)
                curveTo(15.447f, 15.9f, 15.263f, 15.739f, 14.998f, 15.467f)
                curveTo(14.421f, 15.395f, 13.981f, 15.405f, 13.697f, 15.411f)
                curveTo(13.439f, 15.417f, 13.31f, 15.42f, 13.322f, 15.356f)
                curveTo(13.904f, 15.241f, 14.326f, 15.155f, 14.642f, 15.085f)
                curveTo(13.993f, 14.353f, 13.179f, 13.235f, 13.123f, 12.178f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun IranPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Large.Iran,
            contentDescription = "Iran Flag"
        )
    }
}
